import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import {
  collection,
  getDocs,
  query,
  where,
} from "firebase/firestore";

import { db } from "../firebase";

export default function RenovationListings({ filter = {} }) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchRenovationListings = async () => {
      try {
        const q = query(
          collection(db, "listings"),
          where("status", "==", "published"),
          where("marketplaceType", "==", "renovation")
        );

        const snapshot = await getDocs(q);

        const data = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        setItems(data);
      } catch (error) {
        console.error(
          "Error fetching renovation listings:",
          error
        );
      } finally {
        setLoading(false);
      }
    };

    fetchRenovationListings();
  }, []);

  if (loading) {
    return (
      <div className="renovation-listings">
        Loading...
      </div>
    );
  }

  if (items.length === 0) {
    return (
      <div className="renovation-listings">
        {t("listing.noResults")}
      </div>
    );
  }

  return (
    <div className="renovation-listings">

      <div className="renovation-listings-grid">

        {items.map((listing) => {

          const category =
            listing.categories?.[0];

          return (
            <div
              key={listing.id}
              className="listing-card renovation-listing-card"
              onClick={() =>
                navigate(
                  `/renovation/listing/${listing.id}`
                )
              }
            >

              {/* PHOTO */}

              {Array.isArray(listing.photos) &&
                listing.photos.length > 0 && (

                  <img
                    src={listing.photos[0]}
                    alt={listing.title || ""}
                  />

                )}


              {/* CONTENT */}

              <div className="listing-top-row">

                <div className="listing-type">

                  {category
                    ? t(
                        `renovation.categories.${category}`
                      )
                    : t("renovation.pageTitle")}

                </div>

              </div>


              {/* TITLE */}

              <h3 className="renovation-listing-title">

                {listing.title}

              </h3>


              {/* BRAND */}

              {listing.brand && (

                <div className="renovation-listing-brand">

                  {listing.brand}

                </div>

              )}


              {/* PRICE */}

              <div className="listing-price">

                {listing.price
                  ? `${Number(
                      listing.price
                    ).toLocaleString()} ₾`
                  : "—"}

              </div>


              {/* QUANTITY */}

              {listing.quantity && (

                <div className="listing-meta">

                  {listing.quantity}

                  {listing.unit
                    ? ` ${listing.unit}`
                    : ""}

                </div>

              )}


              {/* AVAILABILITY */}

              <div className="renovation-availability">

                {listing.storeAvailable && (
                  <span>
                    🏪{" "}
                    {t(
                      "renovation.storeAvailable"
                    )}
                  </span>
                )}

                {listing.productionAvailable && (
                  <span>
                    🏭{" "}
                    {t(
                      "renovation.productionAvailable"
                    )}
                  </span>
                )}

                {listing.deliveryAvailable && (
                  <span>
                    🚚{" "}
                    {t(
                      "renovation.deliveryAvailable"
                    )}
                  </span>
                )}

              </div>


              {/* DESCRIPTION */}

              {listing.description && (

                <p className="listing-description">

                  {listing.description}

                </p>

              )}

            </div>
          );
        })}

      </div>

    </div>
  );
}
